exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ThreeColumns__statsRow___1f68N {\n  margin-top: 30px;\n}\n.ThreeColumns__statsRow___1f68N [class*='col-'] {\n  margin: 20px 0px;\n}\n@media (min-width: 768px) {\n  .ThreeColumns__statsRow___1f68N [class*='col-'] {\n    padding-left: 20px;\n    padding-right: 20px;\n    margin: 100px 0px;\n  }\n}\n.ThreeColumns__header___1Choz {\n  color: #000;\n  margin-bottom: 10px;\n  margin-top: 5px;\n  font-weight: 700;\n  font-size: 60px;\n  line-height: 60px;\n}\n.ThreeColumns__subtitle___3M1dG {\n  font-size: 22px;\n  text-transform: lowercase;\n  color: #000;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  font-weight: 400;\n}\n.ThreeColumns__infoParagraph___2oNLv {\n  color: #000;\n  font-size: 1em;\n  line-height: 1.6em;\n}\n", ""]);

// exports
exports.locals = {
	"statsRow": "ThreeColumns__statsRow___1f68N",
	"header": "ThreeColumns__header___1Choz",
	"subtitle": "ThreeColumns__subtitle___3M1dG",
	"infoParagraph": "ThreeColumns__infoParagraph___2oNLv"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/components/static/ThreeColumns.styl
// module id = 240
// module chunks = 0